import api from '$lib/api'

export const fetchHealthChecks = async () => {
    
    const res = await api.get('admin/healthcheck')
    
    return res.data
    
}
